/*
 * @Author: your name
 * @Date: 2020-09-22 15:34:38
 * @LastEditTime: 2020-09-25 14:19:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/xdap-h5/src/api/message-remind/index.js
 */
export default {
  module: 'MESSAGE_REMIND',
  // 个人消息提醒
  SAVE_PERSONAL_MESSAGE_REMIND: {
    url: '/xdap-app/schedule/set/personalSchedule',
    method: 'post'
  },
  QUERY_PRESONAL_MESSAGE_REMIND_LIST: {
    url: '/xdap-app/schedule/query/personalSchedule',
    method: 'post',
    disableSuccessMsg: true
  },
  QUERY_PRESONAL_MESSAGE_REMIND_DETAIL: {
    url: '/xdap-app/schedule/get/personalSchedule',
    method: 'post',
    disableSuccessMsg: true
  },
  DELETE_PRESONAL_MESSAGE_REMIND: {
    url: '/xdap-app/schedule/delete/personalSchedule',
    method: 'post'
  }
}
